import { getLocalizedString } from "@icarius-localization/strings";
import {
    Extensibility,
    TrainingAndDevelopmentIcon,
    Settings,
    Publications,
    OrgChartIcon,
    TalentAcquisitionIcon,
    CalculationsManagementIcon,
    CoinsIcon,
    PersonalIcon,
    RequestsIcon,
    TimeManagementIcon,
    ManagementIcon,
    EngagementIcon,
    PerformanceManagementIcon,
    PencilIcon,
} from "@icarius-icons";
import paths from "@icarius-router/paths";

export const getMenuGroupRoutes = () => ({
    settings: {
        isGroup: true,
        title: getLocalizedString("settings"),
        icon: Settings(),
        path: paths.settings,
    },
    extensibility: {
        isGroup: true,
        title: getLocalizedString("extensibility"),
        icon: Extensibility(),
        path: paths.extensibility,
    },
    organizationalDevelopment: {
        isGroup: true,
        title: getLocalizedString("organizationalDevelopment"),
        icon: TrainingAndDevelopmentIcon(),
        path: paths.organizationalDevelopment,
    },
    publications: {
        isGroup: true,
        title: getLocalizedString("publications"),
        icon: Publications(),
        path: paths.publications,
    },
    positions: {
        isGroup: true,
        title: getLocalizedString("cargosMenu"),
        icon: OrgChartIcon(),
        path: paths.positions,
    },
    talentAcquisition: {
        isGroup: true,
        title: getLocalizedString("talentAcquisition"),
        icon: TalentAcquisitionIcon(),
        path: paths.talentAcquisition,
    },
    personal: {
        isGroup: true,
        title: getLocalizedString("Personal"),
        icon: PersonalIcon(),
        path: paths.personal,
    },
    performanceManagement: {
        isGroup: true,
        title: getLocalizedString("performanceManagement"),
        icon: PerformanceManagementIcon(),
        path: paths.performanceManagement,
    },
    remunerations: {
        isGroup: true,
        title: getLocalizedString("Remunerations"),
        icon: CoinsIcon(),
        path: paths.remunerations,
    },
    requestsMenu: {
        isGroup: true,
        title: getLocalizedString("requestsTitle"),
        path: paths.requests,
        icon: RequestsIcon(),
    },
    digitalSignature: {
        isGroup: true,
        title: getLocalizedString("digitalSignature"),
        icon: PencilIcon(),
        path: paths.digitalSignature,
    },
    timeManagement: {
        isGroup: true,
        title: getLocalizedString("timeManagement"),
        icon: TimeManagementIcon(),
        path: paths.timeManagement,
    },
    engagement: {
        isGroup: true,
        title: getLocalizedString("engagement"),
        icon: EngagementIcon(),
        path: paths.engagement,
    },
    management: {
        isGroup: true,
        title: getLocalizedString("managementNav"),
        icon: ManagementIcon(),
        path: paths.management,
    },
    calculationManagement: {
        isGroup: true,
        title: getLocalizedString("calculationManagement"),
        icon: CalculationsManagementIcon(),
        path: paths.calculationManagement,
    },
});